import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Grid from '@mui/material/Box';
import styles from '../styles';


/**
 * A component that allows the user to control a number value.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} props.noteNumber - The current note number.
 * @param {Function} props.setNoteNumber - A function to update the note number.
 * @param {boolean} props.autoIncrement - A flag indicating whether auto-increment is enabled.
 * @param {Function} props.setAutoIncrement - A function to update the auto-increment flag.
 * @param {boolean} props.showNumbers - A flag indicating whether to show the numbers.
 * @param {Function} props.setShowNumbers - A function to update the show numbers flag.
 * @returns {JSX.Element} The rendered NumberControl component.
 */
function NumberControl({
    noteNumber,
    setNoteNumber,
    autoIncrement,
    setAutoIncrement,
    showNumbers,
    setShowNumbers,
}) {
    const [open, setOpen] = useState(false);

    const handleClickOpen = async () => {
        if (!showNumbers) {
            setOpen(true);
        } else {
            setOpen(false);
        }
        setShowNumbers(!showNumbers);
    };

    const handleAutoIncrementChange = async (event) => {
        setAutoIncrement(event.target.checked);
    };

    return (
        <div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Button size='large' variant={showNumbers ? "contained" : "outlined"} onClick={handleClickOpen}>Numbers</Button>
                {open &&
                    <Grid item>
                        <IconButton aria-label="decrement" onClick={() => setNoteNumber(noteNumber - 1)} disabled={!showNumbers}>
                            <RemoveIcon />
                        </IconButton>

                        <span style={{ color: 'black' }}>{noteNumber}</span>
                        <IconButton aria-label="increment" onClick={() => setNoteNumber(noteNumber + 1)} disabled={!showNumbers}>
                            <AddIcon />
                        </IconButton>
                        <FormControlLabel
                            control={<Switch checked={autoIncrement} onChange={handleAutoIncrementChange} />}
                            label="Auto-increment"
                            sx={styles.NoteMetaDataLabel}
                        />
                    </Grid>
                }
            </Grid>
        </div>
    );
}

export default NumberControl;
